module.exports = __webpack_public_path__ + "img/eb51b78.jpg";